import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const responseDataTypeName = 'referred-workspaces'

interface RemoveReferredWorkspaceParams extends WorkspaceIdentifier {
  targetWorkspaceId: string
}

export const useFetchReferredWorkspaces = () => {
  const url = '/v2/referred-workspaces'

  const { get, deleteRequest } = useFetchWithDefaults()

  const getAll = ({ workspaceId }: WorkspaceIdentifier) => get<Response<App.Data.ReferredWorkspaceData[]>>({
    url,
    workspaceId,
  })

  const remove = ({ workspaceId, targetWorkspaceId }: RemoveReferredWorkspaceParams) => deleteRequest({
    url: `${url}/${targetWorkspaceId}`,
    workspaceId,
  })

  return {
    getAll,
    remove,
  }
}
